import React from 'react';
import ReactDOM from 'react-dom/client';
// Tailwind's utilities power shadcn/ui components; app.css (the app's own
// monochrome design system) still owns base element styling since preflight
// is off. Bootstrap is installed but not wired in.
import './styles/tailwind.css';
import './styles/app.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
